import Vue from 'vue'
import Router from 'vue-router'
import bfeach from './beforeEach'

import routes from './routes'

Vue.use(Router)
//console.log(routes)
const router = new Router({
  mode: 'history', // retirar o '#'
  routes
})

router.beforeEach(bfeach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js